import { createFileRoute } from "@tanstack/react-router"

import { TabletLayout } from "@/screens/Tablet/components"
import { uomLoader } from "@/screens/WarehouseReceiving/loaders"

export const Route = createFileRoute("/app/tablet")({
  component: TabletLayout,
  loader: uomLoader,
  staleTime: Infinity,
})
